const LOADING_STATES = {
    CORPORATE_ACCOUNT: 'corporate_account',
    COUNTRIES: 'countries',
    CURRENCIES: 'currencies',
    AVAILABLE_CURRENCIES: 'available_currencies',
    PRODUCTS: 'products',
    REASONS: 'reasons',
    SOURCES: 'sources',
    INITIAL_DEPOSIT: 'initial_deposit',
};
export default LOADING_STATES;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/+applications/new/detail/+details/corporate/new.corporate.loading.states.ts